export default async (data) => {
    const result = app.fetch(`${app.root}ajax/task_price_add.php`, data, 'POST');

    return result;
};
